




























import Vue from 'vue';
import type { PropOptions } from 'vue';
import HeaderMenuNotificationsCardRating from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardRating.vue';
import HeaderMenuNotificationsCardCommission from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardCommission/HeaderMenuNotificationsCardCommission.vue';
import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import HeaderMenuNotificationsCardComment from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardComment.vue';
import HeaderMenuNotificationsCardReply from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardReply.vue';
import HeaderMenuNotificationsCardMention from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardMention.vue';
import ReadNotificationMutation from '@/apollo/mutations/ReadNotification.mutation';
import { getRoute } from '@/components/global/HeaderMenu/HeaderMenuNotifications/utils';
import type { Notification } from '@/types/graphql';
import type { RawLocation } from 'vue-router';
import HeaderMenuNotificationsCardOfficialPost from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardOfficialPost.vue';
import HeaderMenuNotificationsCardMobileAppPost from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardMobileAppPost.vue';
import HeaderMenuNotificationsCardTestimonial from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardTestimonial/HeaderMenuNotificationsCardTestimonial.vue';
import HeaderMenuNotificationsCardConnectionsReminder from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardConnectionsReminder.vue';
import HeaderMenuNotificationsCardRecommendedPost from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardRecommendedPost.vue';
import HeaderMenuNotificationsCardReferral from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardReferral.vue';
import HeaderMenuNotificationsCardJobIntroduction from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardJobIntroduction.vue';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCard',
  components: {
    HeaderMenuNotificationsCardTestimonial,
    HeaderMenuNotificationsCardRating,
    HeaderMenuNotificationsCardCommission,
    HeaderMenuNotificationsCardComment,
    HeaderMenuNotificationsCardReply,
    HeaderMenuNotificationsCardMention,
    HeaderMenuNotificationsCardOfficialPost,
    HeaderMenuNotificationsCardConnectionsReminder,
    HeaderMenuNotificationsCardRecommendedPost,
    HeaderMenuNotificationsCardMobileAppPost,
    HeaderMenuNotificationsCardReferral,
    HeaderMenuNotificationsCardJobIntroduction,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
  computed: {
    isReaction(): boolean {
      const fitByType = [notificationTypes.REACTION_TO_COMMENT, notificationTypes.REACTION_TO_POST].includes(
        this.notification.type,
      );

      return fitByType && !!this.notification.referenceable;
    },
    isComment(): boolean {
      return this.notification.type === notificationTypes.COMMENT;
    },
    isReply(): boolean {
      return this.notification.type === notificationTypes.REPLY_TO_COMMENT;
    },
    isMention(): boolean {
      const fitByType = [notificationTypes.MENTION_IN_COMMENT, notificationTypes.MENTION_IN_POST].includes(
        this.notification.type,
      );

      return fitByType && !!this.notification.referenceable;
    },
    isOfficialPost(): boolean {
      return this.notification.type === notificationTypes.OFFICIAL_POST;
    },
    isContactsReminder(): boolean {
      return this.notification.type === notificationTypes.CONTACTS_REMINDER;
    },
    isTestimonial(): boolean {
      return this.notification.type === notificationTypes.TESTIMONIAL;
    },
    isRecommendedPost(): boolean {
      return this.notification.type === notificationTypes.RECOMMENDED_POST;
    },
    isMobilePost(): boolean {
      return this.notification.type === notificationTypes.MOBILE_APP_POST;
    },
    isReferral(): boolean {
      return [notificationTypes.REFERRAL, notificationTypes.REFERRALHIRED].includes(this.notification.type);
    },
    isJobIntroduction(): boolean {
      return this.notification.type === notificationTypes.JOB_INTRODUCTION;
    },
    referencableRoute(): RawLocation {
      return getRoute(this.notification);
    },
    rootClass(): Record<string, boolean> {
      return {
        'header-menu-notifications-card': true,
        'header-menu-notifications-card--read': this.notification.readAt,
      };
    },
    commissionAmount(): number | undefined {
      return this.notification.warRoomCommissionTransaction?.amount;
    },
  },
  methods: {
    async openReferencable(): Promise<void> {
      if (this.notification.type !== notificationTypes.TESTIMONIAL && !this.notification.readAt) {
        await this.readNotification();
      }

      this.$emit('on-open-referencable');
      this.$analytics.logEvent('header__notifications__notification-card__click', {
        notification_id: this.notification.id,
      });

      await this.$router.push(this.referencableRoute);
    },
    async readNotification(): Promise<void> {
      try {
        await this.$apollo.mutate({
          mutation: ReadNotificationMutation,
          variables: {
            input: { id: this.notification.id },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            readNotification: {
              __typename: 'Notification',
              id: this.notification.id,
              readAt: new Date().toString(),
            },
          },
        });
      } catch (e) {
        this.$notice.error(e);
      }
    },
  },
});
